
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			index: 0
		};
	},
	props: {
		value: Array as ()=>string[]
	},
	computed: {
		title():TranslateResult{
			return this.$ct("common.images");
		},
		url():string{
			if (!this.value) return "";
			if (!this.value[this.index]) return "";
			return this.value[this.index];
		}
	},
	watch: {
		value: {
			handler(){
				this.index = 0;
			}
		}
	},
	methods: {
		onModalInput(value:boolean){
			if (value) return;
			this.$emit("close");
		},
		next(){
			if (this.index == this.value.length-1){
				this.index = 0;
			}else{
				this.index++;
			}
		},
		previous(){
			if (this.index == 0){
				this.index = this.value.length - 1;
			}else{
				this.index--;
			}
		},
		onKeydown(event:KeyboardEvent){
			if (event.key == "ArrowRight") {
				this.next();
			}
			if (event.key == "ArrowLeft"){
				this.previous();
			}
		}
	},
	mounted(){
		window.addEventListener("keydown", this.onKeydown);
	},
	destroyed(){
		window.removeEventListener("keydown", this.onKeydown);
	}

});
